import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=23de6d04&scoped=true&lang=pug&"
var script = {}
import style0 from "./Welcome.vue?vue&type=style&index=0&id=23de6d04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de6d04",
  null
  
)

export default component.exports